const StatusBadge = ({ label, tone = "neutral" }) => {
  if (!label) {
    return null;
  }

  return <span className={`intel-badge intel-badge--${tone}`}>{label}</span>;
};

export default StatusBadge;
